import { transformLocaleUpper } from "..";
const localeMappings = {
  "en-GB": "en",
  "fr-FR": "fr",
  "es-ES": "es",
  "it-IT": "it",
  "de-DE": "de",
  "da-DK": "da",
  "nl-NL": "nl",
  "en-US": "en-us",
  "sv-SE": "sv",
  "nb-NO": "nb",
  "pt-BR": "pt-br"
};
const DEFAULT_LOCALE = "en-GB";
const SUPPORTED_LOCALES = Object.keys(localeMappings);
const ROUTE_BOOK_SIGN_IN_NO_GUEST_OPTION = "/book/login?showRadioButtons=false&loginSource=header";
const isValidLocale = (locale) => SUPPORTED_LOCALES.includes(locale);
const localiseUrl = (url, locale, options = { prefixDefaultLocale: false }) => {
  if (url[0] !== "/") {
    throw new Error(`Expected a domain-relative URL`);
  }
  const localeUpper = transformLocaleUpper(locale);
  const safeLocale = isValidLocale(localeUpper) ? localeUpper : DEFAULT_LOCALE;
  if (safeLocale !== localeUpper) {
    console.warn(`Locale "${localeUpper}" not recognised, falling back to ${DEFAULT_LOCALE}`);
  }
  if (!options.prefixDefaultLocale && safeLocale === DEFAULT_LOCALE) {
    return url;
  }
  const languageCode = localeMappings[safeLocale];
  return `/${languageCode}${url}`;
};
const localiseBookingSigninUrl = (locale) => {
  if (!isValidLocale(locale)) {
    console.warn(`Locale "${locale}" not recognised`);
    return ROUTE_BOOK_SIGN_IN_NO_GUEST_OPTION;
  }
  const languageCode = localeMappings[locale];
  return `${ROUTE_BOOK_SIGN_IN_NO_GUEST_OPTION}&lang=${languageCode}`;
};
var localiseUrl_default = localiseUrl;
export {
  ROUTE_BOOK_SIGN_IN_NO_GUEST_OPTION,
  localiseUrl_default as default,
  localiseBookingSigninUrl
};
